module.exports = __webpack_public_path__ + "static/section-seven-3d6fd7638bd665ea8e664f8120b5eb3f.png";